import { apiRequest } from '../utils/api';

export const TUTOR_UPCOMING_PAGE_SIZE = 10;

export const getTutorBookingSettings = (prospectId) =>
  apiRequest(`/api/v1/bookings/tutor/${prospectId}/booking-settings`);

export const updateTutorBookingSettings = (prospectId, autoAcceptBookingRequests) =>
  apiRequest(`/api/v1/bookings/tutor/${prospectId}/booking-settings`, {
    method: 'PATCH',
    body: JSON.stringify({ autoAcceptBookingRequests }),
  });

export const getBookingRequestDetail = (bookingId) =>
  apiRequest(`/api/v1/bookings/${bookingId}/detail`);

export const acceptTutorBookingRequest = (bookingId) =>
  apiRequest(`/api/v1/bookings/${bookingId}/accept`, {
    method: 'PATCH',
  });

export const declineTutorBookingRequest = (bookingId, reason) =>
  apiRequest(`/api/v1/bookings/${bookingId}/reject`, {
    method: 'PATCH',
    body: reason ? JSON.stringify({ reason }) : undefined,
  });

export const getTutorUpcomingSessions = (
  prospectId,
  { page = 1, limit = TUTOR_UPCOMING_PAGE_SIZE } = {},
) =>
  apiRequest(
    `/api/v1/bookings/tutor/${prospectId}/sessions?status=upcoming&page=${page}&limit=${limit}`,
  );

export const cancelTutorSession = (bookingId) =>
  apiRequest(`/api/v1/bookings/${bookingId}/cancel`, {
    method: 'PATCH',
  });
